module.exports = __webpack_public_path__ + "images/target.png";